export default "__VITE_ASSET__BiGuQQaC__"